export function prepareRange(range) {
  let endDate = new Date()
  let startDate = new Date()
  if (range === 'last-week' || range === 'last-month') {
    return range
  } else if (range === 'last-3-months') {
    startDate.setMonth(startDate.getMonth() - 3)
  } else if (range === 'last-6-months') {
    startDate.setMonth(startDate.getMonth() - 6)
  } else if (range === 'last-year') {
    startDate.setMonth(startDate.getMonth() - 12)
  }

  let startDateStr = `${startDate.getFullYear()}-${
    startDate.getMonth() + 1
  }-${startDate.getDate()}`
  let endDateStr = `${endDate.getFullYear()}-${
    endDate.getMonth() + 1
  }-${endDate.getDate()}`
  return `${startDateStr}:${endDateStr}`
}
